/* eslint-disable */

<template>
    <BaseDialog
        :eager="true"
        :max_width="`90%`"
        :dialog="dialog"
        title="nuovo cliente"
        v-on:close_dialog="closeDialog">
            <ClientEdit
                v-bind:org_id="org_id"
                v-bind:is_childcomponent=true
                v-bind:allowCreateLocation="allowCreateLocation"
                v-on:close_dialog="closeDialog"
                v-on:add_client="addClient"
                ref="client_edit" />
    </BaseDialog>
</template>

<script>
import ClientEdit from "./ClientEdit_new"
import BaseDialog from "../../components/dialogs/BaseDialog"
export default {
    components: {ClientEdit, BaseDialog},
    props: {
        org_id: {
            type: String,
            required: false,
            default: null
        },
        allowCreateLocation: {
            type: Boolean,
            required: false,
            default: true
        },
    },

    data(){
        return {
            dialog: false
        }
    },
    methods: {
        
        closeDialog(){
            this.dialog = false;
        },
        async openDialog(createLocation){
            this.$refs.client_edit.initClient(createLocation) 
            this.$refs.client_edit.reset()
            this.dialog = true;
        },
        addClient(client) {
            this.$emit('addClient', client)
            this.closeDialog()
        }

    },
}
</script>

<style>

</style>
